import { useSettings } from "../contexts/SettingsContext.js";

/**
 * Přepínač jazyka s vlaječkami — CZ / SK / EN.
 * Stav se persistuje do localStorage přes `SettingsContext`.
 * Všechny API calls (viz api.ts) přidávají `?locale=<value>`.
 */
export function LocaleToggle(): JSX.Element {
  const { locale, setLocale } = useSettings();
  const options: Array<{ value: typeof locale; label: string; flag: string; title: string }> = [
    { value: "cs", label: "CZ", flag: "🇨🇿", title: "Čeština" },
    { value: "sk", label: "SK", flag: "🇸🇰", title: "Slovenčina" },
    { value: "en", label: "EN", flag: "🇬🇧", title: "English (original)" },
  ];
  return (
    <div
      role="group"
      aria-label="Jazyk"
      className="inline-flex rounded-lg bg-white/10 p-0.5 text-xs"
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          title={opt.title}
          onClick={() => {
            setLocale(opt.value);
            // Stránky používají useEffect/useState, ne React Query cache — po změně
            // jazyka je nejjednodušší znovu načíst aktuální stránku (všechny komponenty
            // pak zavolají API s novým locale).
            setTimeout(() => window.location.reload(), 50);
          }}
          className={`px-2 min-h-11 sm:min-h-0 py-1 rounded-md transition-colors flex items-center justify-center gap-1.5 ${
            locale === opt.value
              ? "bg-white text-zinc-900 font-medium"
              : "text-zinc-300 hover:text-white"
          }`}
        >
          <span aria-hidden>{opt.flag}</span>
          <span>{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
